import escapeId from "Common/stringUtils/escapeId";
import Popover from "Components/withPopover/popover";
import React, { useMemo, useState } from "react";
import { Chip, TabsTemplate } from "UiKit";
const tabList = [
    {
        key: "NeuralInterface",
        label: "Нейро",
        Popover: undefined,
        isDisabled: false
    },
    {
        key: "Favorites",
        label: "Избранное",
        Popover: "Favorites",
        isDisabled: true
    },
    {
        key: "Popular",
        label: "Популярное",
        Popover: "Popular",
        isDisabled: true
    }
];
const itemSelectorDisabled = ({ isDisabled }) => isDisabled;
const itemSelectorId = ({ key }) => key;
function NeuralInterfaceNavigationTabs({ containerId, className }) {
    const [selectedItem, setSelectedItem] = useState(tabList[0]);
    const position = useMemo(() => ({
        at: "left top",
        my: "left bottom",
        of: `#${escapeId(containerId)}`
    }), [containerId]);
    return (React.createElement("div", null,
        React.createElement(TabsTemplate, { items: tabList, itemRender: ({ data, isActive, isDisabled }) => (React.createElement(Chip, { styleType: "input", size: "md", isActive: isActive, disable: isDisabled },
                React.createElement("span", null, data.label))), getId: itemSelectorId, selectedItem: selectedItem, onClickItem: setSelectedItem, isDisabled: itemSelectorDisabled, direction: "row", classNameContainer: className }),
        React.createElement(Popover, { position: position, target: `#${escapeId(containerId)}`, showEvent: "none", hideEvent: "none", popoverHeight: 320, popoverClassName: "no-border p-0 no-popover-arrow", popoverContent: selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.Popover, visible: Boolean(selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.Popover) })));
}
export default NeuralInterfaceNavigationTabs;
